const stepByStepManifest = {
  featureId: 'step_by_step_view',
  serviceKey: 'action_plan',
  name: 'Action Plan',
  description: 'Generate detailed programs with tools, stages, and durations',
  mode: 'workflow',
  
  steps: [
    {
      id: 'contextual_research',
      title: 'Contextual Research Planning',
      description: 'Creating research approaches tailored to your specific domain',
      status: 'pending',
      agentKey: 'UX_RESEARCH',
      estimatedDuration: 60,
      loadingMessages: [
        'Analyzing your domain context...',
        'Designing research approaches...',
        'Tailoring methodologies to your needs...',
        'Planning research activities...',
        'Building contextual framework...',
      ],
    },
    {
      id: 'custom_programs',
      title: 'Custom Program Generation',
      description: 'Creating bespoke programs and activities for your challenge',
      status: 'pending',
      agentKey: 'UX_DESIGN_LEAD',
      estimatedDuration: 90,
      loadingMessages: [
        'Generating custom programs...',
        'Designing activities for your challenge...',
        'Selecting relevant tools and methods...',
        'Structuring your action plan...',
        'Finalizing program sequence...',
      ],
    },
  ],

  outputs: [
    'detailed_programs',
    'tools',
    'stages',
    'durations',
    'program_sequence',
  ],

  intro: '🚀 Setting up your Action Plan...',
  completion: '✅ **Action Plan Ready!** Your program of work has been created based on your plan.',
};

module.exports = stepByStepManifest;
